// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"map-ruler","clipPath":"url(#clip0_543_3544)"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M15.8573 1.62988L22.2543 8.02694L7.86093 22.4203L1.46387 16.0233L15.8573 1.62988Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M5.06208 12.4248L6.66429 14.027M12.2589 5.22852L13.8611 6.83072M8.66047 8.82617L11.0623 11.228M15.8573 1.62988L22.2543 8.02694L7.86093 22.4203L1.46387 16.0233L15.8573 1.62988Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-map-ruler')
export default class MapRulerIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'map-ruler',
    }
  }
}
